import React, {createContext, useContext, useState, useCallback} from "react";
import {isEqual, isFunction} from "lodash";
import {initialFilter} from "./InternationalCallsUIHelpers";

const InternationalCallsUIContext = createContext();

export function useInternationalCallsUIContext() {
  return useContext(InternationalCallsUIContext);
}

export const InternationalCallsUIConsumer = InternationalCallsUIContext.Consumer;

export function InternationalCallsUIProvider({internationalCallsUIEvents, children}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initInternationalCall = {
    id: undefined,
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    initInternationalCall,
  };

  return <InternationalCallsUIContext.Provider value={value}>{children}</InternationalCallsUIContext.Provider>;
}